<template>
  <div class="report-crime">
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <b-card header="Report Crime">
      <b-form @submit.prevent="submitReport">
        <b-row>
          <b-col md="6" class="mb-3">
            <b-form-group label="Reporting Level">
              <b-form-select v-model="form.CRtype" :options="crTypeOptions" required></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6" class="mb-3">
            <b-form-group label="Crime Type">
              <b-form-select v-model="form.crimeType" :options="crimeTypeOptions" required></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="form.CRtype === 'online'">
          <b-col md="4" class="mb-3">
            <b-form-group label="Source">
              <b-form-select v-model="form.source" :options="sourceOptions" required></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="URL">
              <b-form-input v-model="form.url" type="url"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Medium">
              <b-form-input v-model="form.medium"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="mb-3">
            <b-form-group label="Report Date">
              <b-form-input v-model="form.reportDate" type="date" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Latitude">
              <b-form-input v-model="form.lat" type="number" step="any" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Longitude">
              <b-form-input v-model="form.lon" type="number" step="any" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="mb-3">
            <b-form-group label="Known Species?">
              <b-form-radio-group v-model="form.knownSpecies" :options="yesNoOptions" required></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3" v-if="form.knownSpecies === 'yes'">
            <b-form-group label="Included in Digital Guide?">
              <b-form-radio-group v-model="form.includeinSpecies" :options="yesNoOptions" required></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3" v-if="form.knownSpecies === 'yes' && form.includeinSpecies === 'yes'">
            <b-form-group label="Select Species">
              <b-form-select v-model="form.species" :options="speciesOptions" required></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3" v-if="form.knownSpecies === 'yes' && form.includeinSpecies === 'no'">
            <b-form-group label="Species Name">
              <b-form-input v-model="form.speciesName" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label="Description" class="mb-3">
          <b-form-textarea v-model="form.description" rows="3"></b-form-textarea>
        </b-form-group>

        <h5 class="mt-4 mb-3">Contributor Details (Optional)</h5>
        <b-row>
          <b-col md="4" class="mb-3">
            <b-form-group label="Name">
              <b-form-input v-model="form.contributorName"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Email">
              <b-form-input v-model="form.contributorEmail" type="email"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Phone">
              <b-form-input v-model="form.contributorPhone"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <h5 class="mt-4 mb-3">Media Uploads</h5>
        <b-row>
          <b-col md="3" class="mb-3">
            <b-form-group label="Photos">
              <b-form-file multiple accept="image/*" v-model="files.photos"></b-form-file>
            </b-form-group>
          </b-col>
          <b-col md="3" class="mb-3">
            <b-form-group label="Videos">
              <b-form-file multiple accept="video/*" v-model="files.videos"></b-form-file>
            </b-form-group>
          </b-col>
          <b-col md="3" class="mb-3">
            <b-form-group label="Audio Clips">
              <b-form-file multiple accept="audio/*" v-model="files.audioClips"></b-form-file>
            </b-form-group>
          </b-col>
          <b-col md="3" class="mb-3">
            <b-form-group label="Documents">
              <b-form-file multiple accept=".pdf,.doc,.docx" v-model="files.documents"></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="mt-4 text-center">
          <b-button type="submit" variant="primary" size="lg">Submit Crime Report</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'ReportCrime',
  components: {
    VueElementLoading,
  },
  data () {
    return {
      visible: false,
      form: {
        CRtype: 'groundlevel',
        crimeType: null,
        knownSpecies: 'no',
        includeinSpecies: 'no',
        species: null,
        speciesName: '',
        source: null,
        url: '',
        medium: '',
        description: '',
        reportDate: '',
        lat: '',
        lon: '',
        anonymous: 'no', // For admin/analyst submitting directly
        contributorName: '',
        contributorEmail: '',
        contributorPhone: '',
      },
      files: {
        photos: [],
        videos: [],
        audioClips: [],
        documents: [],
      },
      crTypeOptions: [
        { value: 'groundlevel', text: 'Field Reporting' },
        { value: 'online', text: 'Online Reporting' },
      ],
      yesNoOptions: [
        { value: 'yes', text: 'Yes' },
        { value: 'no', text: 'No' },
      ],
      crimeTypeOptions: [],
      sourceOptions: [],
      speciesOptions: [],
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.visible = true
      try {
        const [ctRes, srcRes, spRes] = await Promise.all([
          axios.get('/crimetype/list', { headers: { token: localStorage.getItem('token') } }),
          axios.post('/source/list', {}, { headers: { token: localStorage.getItem('token') } }),
          axios.post('/species/list', {}, { headers: { token: localStorage.getItem('token') } }),
        ])

        if (ctRes.data.status) {
          this.crimeTypeOptions = ctRes.data.data.map(c => ({ value: c._id, text: c.cname }))
        }
        if (srcRes.data.status) {
          this.sourceOptions = srcRes.data.data.map(s => ({ value: s._id, text: s.sname }))
        }
        if (spRes.data.status) {
          this.speciesOptions = spRes.data.data.map(s => ({ value: s._id, text: s.commonName || s.scientificName }))
        }
      } catch (err) {
        console.error('Failed to load form options:', err)
      } finally {
        this.visible = false
      }
    },
    async submitReport () {
      this.visible = true

      const formData = new FormData()
      Object.keys(this.form).forEach(key => {
        if (this.form[key]) {
          formData.append(key, this.form[key])
        }
      })
      formData.append('anonymous', 'no') // Ensure analyst is tracked

      // Append files
      Object.keys(this.files).forEach(key => {
        if (this.files[key] && this.files[key].length > 0) {
          for (let i = 0; i < this.files[key].length; i++) {
            formData.append(key, this.files[key][i])
          }
        }
      })

      try {
        const response = await axios.post('/crimereport/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            token: localStorage.getItem('token'),
          },
        })

        if (response.data.status) {
          alert('Crime reported successfully!')
          this.$router.push('/dashboard')
        } else {
          alert(response.data.msg || 'Failed to report crime')
        }
      } catch (err) {
        console.error(err)
        alert('An error occurred during submission.')
      } finally {
        this.visible = false
      }
    },
  },
}
</script>

<style scoped>
.report-crime {
  padding: 20px;
}
</style>
